import httpAdapter, { HttpMethod, ApiVersion, ContentType } from "../../utils/http-adaper";

const GenericApi = {
  getCommunitiesByReligionId: async ({ religionId }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "generic/communities",
      authneticated: false,
      queryParams: { religionId },
    });
  },
  getCountryRegionsByCountryCode: async ({ countryCode }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "generic/regions",
      authneticated: false,
      queryParams: { countryCode },
    });
  },
  getPricingPackages: async ({ showNew, isRenew = true }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "generic/pricing_tiers",
      authneticated: false,
      queryParams: { showNew, isRenew },
    });
  },
  getVipRequests: async ({ page, limit }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/vip-requests",
      authneticated: true,
      queryParams: { pageNum: page, pageSize: limit },
    });
  },
  getAppConfig: async () => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "generic/config_new",
      authneticated: false,
    });
  },
  getGenericFilters: async () => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "generic/filters",
      authneticated: false,
    });
  },
  genericUpload: async ({formData}) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: "generic/upload",
      body:formData,
      contentType:ContentType.FORM_DATA,
      authneticated: true,
    });
  },
};

export default GenericApi;
